import React, { useEffect, useState } from "react";
import { api, fmtDate, fmtNum } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Loader2, ArrowDownRight, ArrowUpRight } from "lucide-react";

export default function InventoryMovements() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/inventory-movements").then(({ data }) => setRows(data)).catch(() => setRows([])); }, []);
  if (!rows) return <div className="py-20 text-center text-slate-400"><Loader2 className="h-6 w-6 animate-spin inline" /></div>;
  return (
    <div>
      <div className="mb-5">
        <h1 className="font-head text-2xl font-bold tracking-tight text-slate-900">Inventory Movements</h1>
        <p className="text-sm text-slate-500 mt-0.5">Every movement references a source transaction (system of record).</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <Table className="pf-table">
            <TableHeader>
              <TableRow className="bg-slate-50 hover:bg-slate-50">
                {["Time", "Type", "Tank", "Product", "Quantity", "Source", "By"].map((h) => (
                  <TableHead key={h} className="text-[11px] uppercase tracking-wide text-slate-500 font-semibold py-2.5 px-3">{h}</TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((m) => (
                <TableRow key={m.id} className="border-slate-100" data-testid={`movement-row-${m.id}`}>
                  <TableCell className="py-2 px-3 text-xs text-slate-500 whitespace-nowrap">{fmtDate(m.created_at)}</TableCell>
                  <TableCell className="py-2 px-3 text-[13px]">
                    <span className={`inline-flex items-center gap-1 font-medium ${m.quantity >= 0 ? "text-emerald-600" : "text-rose-600"}`}>
                      {m.quantity >= 0 ? <ArrowDownRight className="h-3.5 w-3.5" /> : <ArrowUpRight className="h-3.5 w-3.5" />}{m.type}
                    </span>
                  </TableCell>
                  <TableCell className="py-2 px-3 mono text-xs">{m.tank_no}</TableCell>
                  <TableCell className="py-2 px-3 text-[13px] text-slate-700">{m.product_name}</TableCell>
                  <TableCell className={`py-2 px-3 tabular font-semibold ${m.quantity >= 0 ? "text-emerald-600" : "text-rose-600"}`}>{fmtNum(m.quantity)} L</TableCell>
                  <TableCell className="py-2 px-3 mono text-xs text-slate-500">{m.source_no}</TableCell>
                  <TableCell className="py-2 px-3 text-xs text-slate-500">{m.by}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
